import React from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import ColorPicker from "../common/ColorPicker"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
	tagWrapper: {
		top: "18%",
		left: "50%",
	},
}))

const CreateTag = (props) => {
	const classes = useStyles()
	const [t] = useTranslation("global")
	return (
		<div className={`${classes.tagWrapper} ${props?.show ? "show divCreateCustomTags" : "hide"}`} ref={props?.innerRef}>
			<div className="col-3">
				<div className="col-12">
					<h5>{t("tag.createTag")}</h5>
				</div>
				<div className="col-12 mb-3">
					<ColorPicker />
				</div>
			</div>
		</div>
	)
}

export default CreateTag
